<script>
import ProNav from '$common/ProNav'
import GuardianNav from '$routed/Guardian/GuardianNav'
export default {
  name: 'GuardianMain',
  components: {
    'top-nav': ProNav,
    'side-nav': GuardianNav,
  },
  methods: {
    checkFirstTime () {
      const isFirstTime = !!this.$cookies.get('first-time')
      if (isFirstTime) {
        this.$cookies.remove('first-time')
        this.$modals.show({
          name: 'first-time',
        })
      }
    },
  },
  mounted () {
    this.checkFirstTime()
  },
}
</script>

<template lang="pug">
  .guardian-main-main
    .guardian-main-container
      top-nav
      .guardian-content
        side-nav
        router-view.guardian-router-view
</template>

<style lang="sass" scoped>
  .guardian-main-main
    .guardian-main-container
      .guardian-content
        display: grid
        grid-template-columns: min-content auto
        .guardian-router-view
          border-top: thin solid $mediumgrey
        @media(max-width:700px)
          grid-template-columns: 100vw
</style>